import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
const Nosotros = () => {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-256">
      <Header data-id="element-257" />
      <main data-id="element-258">
        <About data-id="element-259" />
      </main>
      <Footer data-id="element-260" />
    </div>;
};
export default Nosotros;